import { connect } from 'react-redux';
import find from 'lodash/find';
import fontFamilies from 'configs/font-families';

import GoogleTranslate from 'components/hub-page/views/sections/integrations/google-translate';

const mapStateToProps = (state) => {
  const fetchedContentFont = find(
    fontFamilies,
    (f) => f.key === state.theme.theme.contentFont,
  );

  return {
    locale: state.currentSite.site.locale,
    googleTranslateIntegration:
      state.googleTranslateIntegration.googleTranslateIntegration,
    fontFamily:
      (fetchedContentFont && fetchedContentFont.name) || fontFamilies[0].name,
    nonce: state.hubPageRevision.nonce,
    dataTestId: 'participant-hubs-views-integration-section-google-translate',
  };
};

export default connect(mapStateToProps)(GoogleTranslate);
